import React from "react";
import "./CloudManageSuite.css";
import img from "../cloudmanageassets/suite.png";
import check from "../cloudmanageassets/imgcheck.png";

export default function CloudManageSuite() {
  return (
    <div id="manage-suite" className="outsourcemainclass">
      <div className="right">
        <h2 className="heading">What Is DevOps Scalability?</h2>
        <p className="subheading">
        End-to-end services designed to support, optimize, and scale your business
        </p>
        <ul>
            <li><img src={check} alt="error" />Cloud Deployment</li>
            <li><img src={check} alt="error" />Backup and Disaster Recovery</li>
            <li><img src={check} alt="error" />Cloud Migration</li>
            <li><img src={check} alt="error" />Infrastructure Setup and Management</li>
            <li><img src={check} alt="error" />Cloud Cost Optimization</li>
            <li><img src={check} alt="error" />Cloud Monitoring and Reporting</li>
            <li><img src={check} alt="error" />Automation and DevOps</li>
            <li><img src={check} alt="error" />Cloud Security and Compliance</li>
        </ul>
     </div>
       <div className="left">
        <img src={img} alt="error" />
      </div>
    </div>
  );
}
